module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABoAAAAaCAYAAACpSkzOAAAAAXNSR0IArs4c6QAAAARzQklUCAgICHwIZIgAAAD4SURBVEiJtdQ9DoJAEAXgx48HQC5igfcw0cJjQGxMCMkkxFjCLbSx8Bw03oMAHgBcCwpFxTDDMt3uZvLlJbMDMIvC3KMw97h9JguJCh+mlcG0MorK42QQYOzeDnuKimQaSOH6AftDMR5kOz6gLhLMYEEAiJSNpjwDxrr7olKK3UAbJMVEkAQTQ1xsFMTBRkNDMeaH7YOMGtZ8+3v02w2iJdEL7En2aJZaEnXLVF9XM7vWBrVp7idAbbovKiBybhqHoQeJ3RTQNt7/kdHQUGQUxEHEEBcRQRKEDUkRALA5EJoqAcBGAP6uW0kQCXSQIKKiMPeIqgW37wlcnLFSDMv8TQAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/padImg/m4.png
// module id = JiFB
// module chunks = 1